<mat-form-field
floatLabel="'always'"
appearance="fill"
[ngClass]="'add-automtic-form-desing'"
style="width: 100% !important"
class="automtic-form-desing-form-only"
>
<input
  style="position: relative;top: -6px;"
  [(ngModel)]="form_name"
  matInput
  id="text-giv"
  placeholder="Name"
  type="text"

/>

</mat-form-field>